import AbstractLayer from "./AbstractLayer";

interface IMapboxVectorLayerProps {
  map: any;
  layer: any;
}

export default class MapboxVectorLayer extends AbstractLayer {
  public props: IMapboxVectorLayerProps;
  public componentDidMount() {
    const { layer, map } = this.props;
    const mapboxBaseLayerId = this.createMapboxId();
    const mapboxFillLayerId = mapboxBaseLayerId + "-fill";
    const mapboxLineLayerId = mapboxBaseLayerId + "-outline";

    if (layer.vector_type === "line") {
      createLineLayer(map, layer, mapboxLineLayerId);
    } else if (layer.vector_type === "line_and_fill") {
      createFillWithOutline(map, layer, mapboxFillLayerId, mapboxLineLayerId);
    } else if (layer.vector_type === "circle") {
      createCircleLayer(map, layer, mapboxBaseLayerId);
    } else {
      console.error(
        `Failed to render vector layer because of unknown vector type. ` +
          `Layer with ID <<${layer.id}>> and vector type <<${layer.vector_type}>>`
      );
    }
  }

  public render() {
    return null;
  }
}

function createFillWithOutline(map, layer, fillId, outlineId) {
  createFillLayer(map, layer, fillId);
  createLineLayer(map, layer, outlineId);
}

function createFillLayer(map, layer, mapboxLayerId) {
  const { color, opacity } = layer.render_properties;
  const layerStyle = {
    id: mapboxLayerId,
    type: "fill",
    "source-layer": layer.source_layer,
    source: {
      type: "vector",
      url: `mapbox://${layer.source}`,
    },
    paint: {
      "fill-color": color || "#00E5EE",
      "fill-opacity": opacity || 0.3,
    },
    layout: {
      visibility: layer.visible ? "visible" : "none",
    },
  };

  map.addLayer(layerStyle);
  layer.connectMapbox(mapboxLayerId, map);
}

function createLineLayer(map, layer, mapboxLayerId) {
  const { color, line_width } = layer.render_properties;
  const layerStyle = {
    id: mapboxLayerId,
    type: "line",
    "source-layer": layer.source_layer,
    source: {
      type: "vector",
      url: `mapbox://${layer.source}`,
    },
    paint: {
      "line-color": color || "#00E5EE",
      "line-width": line_width || 1,
    },
    layout: {
      visibility: layer.visible ? "visible" : "none",
    },
  };

  map.addLayer(layerStyle);
  layer.connectMapbox(mapboxLayerId, map);
}

function createCircleLayer(map, layer, mapboxLayerId) {
  const layerStyle = {
    id: mapboxLayerId,
    type: "circle",
    source: {
      type: "vector",
      url: `mapbox://${layer.source}`,
    },
    "source-layer": layer.source_layer,
    layout: {
      visibility: layer.visible ? "visible" : "none",
    },
    paint: {
      "circle-radius": layer.render_properties.circle_radius || 3,
      "circle-color": layer.render_properties.color || "#00E5EE",
      "circle-opacity": layer.render_properties.opacity || 1,
      "circle-stroke-color": layer.render_properties.stroke_color || "#000",
      "circle-stroke-width": layer.render_properties.stroke_width || 0,
    },
  };

  map.addLayer(layerStyle);
  layer.connectMapbox(mapboxLayerId, map);
}
